import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginConvocatoriaComponent } from './pages/login-convocatoria/login-convocatoria.component';
import { HomeComponent } from './pages/home/home.component';
import { CustomPreloadingStrategyService } from "./services/custom-preloading-strategy.service";

const routes: Routes = [
	{ path: '', redirectTo: '/home', pathMatch: 'full' },
	{ path: 'login', component: LoginComponent },
	{ path: 'login-convocatoria', component: LoginConvocatoriaComponent },
	{
		path: 'home',
		component: HomeComponent,
		children: [
			{
				path: '', component: DashboardComponent
			},
			{
				path: 'personal',
				loadChildren: () => import('./projects/personal/personal.module').then(p => p.PersonalModule),
				data: { preload: true },
			},
			{
				path: 'encuestas',
				loadChildren: './projects/encuestas/encuestas.module#EncuestasModule'
			},
			{
				path: 'convocatoria',
				loadChildren: './projects/convocatoria/convocatoria.module#ConvocatoriaModule'
			},
			{
				path: 'astk',
				loadChildren: () => import('./projects/asterisk/asterisk.module').then(m => m.AsteriskModule)
			},
			{
				path: 'activos/ti',
				loadChildren: () => import('./projects/activos-ti/activos-ti.module').then(m => m.ActivosTiModule)
			}
		]
	},
	{ path: '**', redirectTo: '/home' },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: CustomPreloadingStrategyService }),
	],
	exports: [RouterModule],
	providers: [CustomPreloadingStrategyService]
})
export class AppRoutingModule { }
